import * as React from 'react'
import styled from 'styled-components'
import { getPhotoCol } from 'fb'

const ImageCenter = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
`

class Details extends React.Component<DetailsProps> {
  public state: { url: string, error: boolean } = { url: '', error: false }

  public async componentDidMount() {
    const { match: { params: { id } } } = this.props
    try {
      const snapshot: DocumentSnapshot = await getPhotoCol().doc(id).get()
      snapshot.exists
        ? this.setState({ url: (snapshot.data() as ThumbnailObject).url })
        : this.setState({ error: true })
    } catch (ex) {
      this.setState({ error: true })
    }
  }

  public render() {
    if (this.state.error) { return <h1>이미지를 찾을 수 없습니다.</h1> }
    return this.state.url ? <ImageCenter src={this.state.url} /> : <h1>Loading...</h1>
  }
}

export default Details

import * as firebase from 'firebase'
import DocumentSnapshot = firebase.firestore.DocumentSnapshot
import { ThumbnailObject } from 'containers/ThumbnailList'

interface DetailsProps {
  match: { params: { tag: string, id: string } }
}



// WEBPACK FOOTER //
// ./src/containers/Details/index.tsx